export function extractEntitiesFromData(
    entities,
    previousState,
    shouldReplace = false,
    transformEntity = (newEntity, storedEntity) => newEntity
) {
    if (entities)
        return entities.reduce(
            (storedEntityData, newEntity) => ({
                ...storedEntityData,
                [newEntity.id]: applyTransformation(
                    storedEntityData[newEntity.id],
                    newEntity,
                    shouldReplace,
                    transformEntity
                )
            }),
            previousState
        )
    return previousState
}

function applyTransformation(
    storedEntity,
    newEntity,
    shouldReplace,
    transformEntity
) {
    const newTransformedEntity = transformEntity(newEntity, storedEntity)
    return shouldReplace
        ? newTransformedEntity
        : {
              ...storedEntity,
              ...newTransformedEntity
          }
}
